/**
 * The entry card's guard (owner, 2026-10-17; ADR 0071): the sign-up trap's value and a fresh identity challenge solved
 * for the step (`../../api/identity-challenge.ts` solves it; the api gateway would solve one itself if none were
 * passed, but only this card knows the trap field's value). Nothing is drawn: the proof of work costs a person well
 * under a second, while the button already says "Checking…".
 */
import type { SubtleLike } from "@wetalk/help-widget/anonymous";

import type { ConsoleGateway, EntryGuardView } from "../../api/gateway.js";
import { IdentityChallengeUnsolvedError, solvedIdentityChallengeOf } from "../../api/identity-challenge.js";

export { IdentityChallengeUnsolvedError };

/** A fresh identity challenge, solved: the `altcha` value of one step. */
export function solvedIdentityChallenge(gateway: ConsoleGateway, subtle?: SubtleLike): Promise<string> {
  return solvedIdentityChallengeOf(() => gateway.readIdentityChallenge(), subtle);
}

/** What one step sends beside its fields: the trap's value and its own solved challenge. */
export async function entryGuardOf(gateway: ConsoleGateway, entryMarker: string): Promise<EntryGuardView> {
  return { entryMarker, altcha: await solvedIdentityChallenge(gateway) };
}
